import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FieldSchema } from '@lsq-frontend/remote-services/ar-app';

export function documentListRequestForm(): FormGroup {
    const formGroup: FormGroup = new FormGroup({
        documentListSelect: new FormControl('', [Validators.required]),
        scheduleRequest: new FormControl(),
        startDate: new FormControl(),
        repeatEvery: new FormControl(),
        repeats: new FormControl()
    });

    return formGroup;
}
